export default "__VITE_ASSET__p35pPaG$__"